export interface Level {
  level: number;
  xp: number;
}


export const userLevels: Level[] = [
  { level: 1, xp: 0 },
  { level: 2, xp: 20 },
  { level: 3, xp: 40 },
  { level: 4, xp: 60 },
  { level: 5, xp: 80 },
  { level: 6, xp: 120 },
  { level: 7, xp: 160 },
  { level: 8, xp: 200 },
  { level: 9, xp: 240 },
  { level: 10, xp: 280 },
  { level: 11, xp: 360 },
  { level: 12, xp: 440 },
  { level: 13, xp: 520 },
  { level: 14, xp: 600 },
  { level: 15, xp: 680 },
  { level: 16, xp: 840 },
  { level: 17, xp: 1000 },
  { level: 18, xp: 1160 },
  { level: 19, xp: 1320 },
  { level: 20, xp: 1480 }
];

export const cropLevels: Level[] = [
  { level: 1, xp: 0 },
  { level: 2, xp: 20 },
  { level: 3, xp: 40 },
  { level: 4, xp: 60 },
  { level: 5, xp: 80 },
  { level: 6, xp: 120 },
  { level: 7, xp: 160 },
  { level: 8, xp: 200 },
  { level: 9, xp: 240 },
  { level: 10, xp: 280 },
  { level: 11, xp: 360 },
  { level: 12, xp: 440 },
  { level: 13, xp: 520 },
  { level: 14, xp: 600 },
  { level: 15, xp: 680 },
  { level: 16, xp: 840 },
  { level: 17, xp: 1000 },
  { level: 18, xp: 1160 },
  { level: 19, xp: 1320 },
  { level: 20, xp: 1480 }
];